/* Noir — thème Shopify */
(function(){
"use strict";
const $ = s => document.querySelector(s);
const LNG=(document.documentElement.lang||"fr").slice(0,2);
const I18N=Object.assign({added:"Ajouté ✓",empty:"Votre panier est vide.",cupEyebrow:"Céramique — fabriquée en France",perPiece:"/ pièce",dec:"Réduire",inc:"Augmenter",remove:"Retirer",shipMore:"Plus que %s pour la livraison offerte en France.",shipOk:"Livraison offerte en France ✓",instore:"En vente dans nos coffee shops — bientôt en ligne.",chooseGrind:"Choisir la mouture…",grindReq:"Choisissez une mouture."},window.NOIR_I18N||{});
const pickL=v=>v&&typeof v==="object"&&!Array.isArray(v)?(v[LNG]||v.fr):v;
const fmtc = c => (c/100).toFixed(2).replace(".",",") + " €";
const hkey = h => (h||"").replace(/-\d+$/,"");
function imgFallback(im){
  im.addEventListener("error", function h(){
    if(im.dataset.fb1){ im.src = im.dataset.fb1; im.removeAttribute("data-fb1"); }
    else if(im.dataset.fb2){ im.src = im.dataset.fb2; im.removeAttribute("data-fb2"); }
    else { im.removeEventListener("error", h); im.style.visibility="hidden"; const c=im.closest(".cell"); if(c) c.classList.add("noimg"); }
  });
}

/* ---- données produit (specs étiquette) — clé = handle Shopify ---- */
const DATA = {
 "sitio-da-torre":{color:"#6a1932",a:1,b:3,s:3,origin:{fr:"Brésil — Minas Gerais",en:"Brazil — Minas Gerais",es:"Brasil — Minas Gerais"},process:"Pulped natural",flav:"Almond, blueberry, chocolate",sca:"85",
  specs:[["Origin","Brazil, Minas Gerais"],["Producer","Silva Family — Sitio da Torre"],["Variety","Yellow Bourbon"],["Location","Mantiqueira de Minas, Carmo"],["Altitude","1100–1300 masl"],["Process","Pulped natural"],["Drying","Patio and mechanical"]]},
 "los-chelazos":{color:"#a05621",a:1.5,b:2.5,s:2.5,origin:{fr:"Salvador — Chalatenango",en:"El Salvador — Chalatenango",es:"El Salvador — Chalatenango"},process:"Washed",flav:"Biscuits, black tea, macadamia",sca:"85.75",
  specs:[["Origin","El Salvador, Chalatenango"],["Producer","Los Chelazos"],["Variety","Pacas, Catuai, Bourbon, Caturra"],["Location","La Palma, San Ignacio"],["Altitude","1200–1800 masl"],["Process","Washed"],["Drying","Dried on raised beds"]]},
 "nyamyumba":{color:"#2f51dc",a:2,b:2.5,s:3,origin:{fr:"Rwanda — Western Province",en:"Rwanda — Western Province",es:"Ruanda — Provincia Occidental"},process:"Natural",flav:"Blackberry, milk chocolate, vanilla",sca:"85.5",
  specs:[["Origin","Rwanda, Western Province"],["Producer","Nyamyumba Washing Station"],["Variety","Bourbon"],["Location","Rubavu, Nyamyumba"],["Altitude","1500–2000 masl"],["Process","Natural"],["Drying","Raised african beds"]]},
 "penachi":{color:"#3f0a78",a:1.5,b:2.5,s:3,origin:{fr:"Pérou — Amazonas",en:"Peru — Amazonas",es:"Perú — Amazonas"},process:"Washed",flav:"Chocolate, praline, tropical fruit",sca:"85",
  specs:[["Origin","Peru, Amazonas Province"],["Producer","Comite Penachi, R. de Mendoza"],["Variety","Bourbon, Catuai, Caturra, Typica"],["Location","Chachapoyas, Chiliquin"],["Altitude","1400–2000 masl"],["Process","Washed"],["Drying","Raised african beds"]]},
 "chelbesa":{color:"#f5c1a8",a:4,b:2,s:3.5,origin:{fr:"Éthiopie — Yirgacheffe",en:"Ethiopia — Yirgacheffe",es:"Etiopía — Yirgacheffe"},process:"Washed",flav:"Kumquat, peach, jasmin",sca:"87",
  specs:[["Origin","Ethiopia, Yirgacheffe"],["Producer","Chelbesa — SNAP"],["Variety","Heirloom"],["Location","Gedeb, Gedeo"],["Altitude","1950–2200 masl"],["Process","Washed"],["Drying","Raised African beds"]]},
 "kianyangi":{color:"#fcca01",a:4.5,b:3,s:3.5,origin:{fr:"Kenya — Embu",en:"Kenya — Embu County",es:"Kenia — Embu"},process:"Fully washed",flav:"Orange blossom, cassis, caramel",sca:"87",
  specs:[["Origin","Kenya, Embu County"],["Producer","Kianyangi factory"],["Variety","Batian, Ruiru 11, SL28, SL34"],["Location","Manyatta"],["Altitude","1750 masl"],["Process","Fully washed"],["Drying","Raised African beds"]]},
 "gasharu":{color:"#94c689",a:3,b:2.5,s:3,origin:{fr:"Rwanda — Nyamasheke",en:"Rwanda — Nyamasheke",es:"Ruanda — Nyamasheke"},process:{fr:"Anaérobie 60 h",en:"Anaerobic 60 h",es:"Anaeróbico 60 h"},flav:"Mango, raisins, cocoa nibs",sca:"86.5",
  specs:[["Origin","Rwanda, Nyamasheke dist."],["Producer","Valentin Kimenyi"],["Variety","Red Bourbon"],["Location","Macuba, Gasharu"],["Altitude","1800–2110 masl"],["Process","Anaerobic fermentation — 60h"],["Drying","African beds"]]},
 "hambela-fw":{color:"#457376",a:2.5,b:2,s:2.5,origin:{fr:"Éthiopie — Guji",en:"Ethiopia — Guji",es:"Etiopía — Guji"},process:"Fully washed",flav:"Jasmin, orangina, apricot",sca:"86.25",
  specs:[["Origin","Ethiopia, Oromia"],["Producer","Dimtu Coffee Industry"],["Variety","Heirloom — Grade 1"],["Location","Guji zone, Shakiso, Hambela"],["Altitude","1850–1950 masl"],["Process","Fully washed"],["Drying","Raised beds"]]},
 "las-brisas":{color:"#018c7f",a:3,b:2,s:2.5,origin:{fr:"Colombie — Huila",en:"Colombia — Huila",es:"Colombia — Huila"},process:{fr:"Natural anaérobie",en:"Natural anaerobic",es:"Natural anaeróbico"},flav:"Pineapple, blueberry, caramel",sca:"86.5",
  specs:[["Origin","Colombia, Huila"],["Producer","Wilmer Cuellar"],["Variety","Pacamara"],["Location","Acevedo, Las Brisas"],["Altitude","1600–1650 masl"],["Process","Natural anaerobic"],["Drying","Parabolic and mechanical dryer"]]},
 "nasa-deca":{color:"#d07d0c",a:1.5,b:2.5,s:2.5,origin:{fr:"Colombie — Tolima · Déca",en:"Colombia — Tolima · Decaf",es:"Colombia — Tolima · Descafeinado"},process:"Sugar cane",flav:"Dried figs, cranberry, quark",sca:"86",
  specs:[["Origin","Colombia, Tolima"],["Producer","ASCISP Cooperative"],["Variety","Caturra, colombia, castillo, typica"],["Location","Planadas and Gaitania, Nasa Wesx"],["Altitude","1700–2000 masl"],["Process","Natural, sugar cane decaffeination"],["Drying","Greenhouse"]]}
};

/* ---- panier AJAX ---- */
function openDrawer(){ $("#drawer").classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow="hidden"; }
function closeDrawer(){ $("#drawer").classList.remove("open"); $("#overlay").classList.remove("open"); document.body.style.overflow=""; }

function renderCart(cart){
  const items = $("#cartItems"); if(!items) return;
  items.innerHTML = "";
  if(!cart.item_count){
    items.innerHTML = '<div class="cempty">'+I18N.empty+'</div>';
  } else {
    cart.items.forEach(li=>{
      const d = document.createElement("div"); d.className = "citem";
      const base = document.body.dataset.assets || "";
      const img = li.image ? li.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2")
                : (base ? base + hkey(li.handle) + ".webp" : "");
      d.innerHTML =
        '<img src="'+img+'" alt="" onerror="this.style.visibility=&quot;hidden&quot;">' +
        '<div><div class="ci-name">'+li.product_title+'</div>'+((li.variant_title&&li.variant_title!=="Default Title")?'<div class="ci-var">'+li.variant_title+'</div>':'')+'<div class="ci-price">'+fmtc(li.price)+'</div></div>' +
        '<div class="qty"><button aria-label="'+I18N.dec+'">−</button><span>'+li.quantity+'</span><button aria-label="'+I18N.inc+'">+</button></div>' +
        '<button class="rm" aria-label="'+I18N.remove+'">✕</button>';
      const btns = d.querySelectorAll(".qty button");
      btns[0].addEventListener("click", ()=>changeLine(li.key, li.quantity-1));
      btns[1].addEventListener("click", ()=>changeLine(li.key, li.quantity+1));
      d.querySelector(".rm").addEventListener("click", ()=>changeLine(li.key, 0));
      items.appendChild(d);
    });
  }
  $("#cartCount").textContent = cart.item_count;
  const FS=5000, bar=$("#shipBar");
  if(bar){
    if(!cart.item_count){ bar.hidden=true; }
    else{
      bar.hidden=false;
      const rem=FS-cart.total_price;
      if(rem>0){ $("#shipMsg").textContent=I18N.shipMore.replace("%s",fmtc(rem)); $("#shipFill").style.width=Math.min(100,cart.total_price/FS*100)+"%"; }
      else{ $("#shipMsg").textContent=I18N.shipOk; $("#shipFill").style.width="100%"; }
    }
  }
  $("#cartTotal").textContent = fmtc(cart.total_price);
}
function refreshCart(){ return fetch("/cart.js").then(r=>r.json()).then(renderCart); }
function changeLine(key, q){
  fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({id:key, quantity:q})}).then(r=>r.json()).then(renderCart);
}
function addToCart(vid, q){
  return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({id:Number(vid), quantity:q||1})})
    .then(r=>{ if(!r.ok) throw 0; return refreshCart(); });
}

window.Noir = { add:addToCart, openDrawer:openDrawer };

/* ---- garde-fou : aucun titre ne déborde jamais ---- */
function fitTitles(){
  document.querySelectorAll(".giant,.mmlinks a,.prorow .w,.offer .w").forEach(el=>{
    el.style.fontSize="";
    if(!el.clientWidth) return;
    let fs = parseFloat(getComputedStyle(el).fontSize), guard=40;
    while(el.scrollWidth > el.clientWidth + 1 && fs > 14 && guard--){
      fs -= 1; el.style.fontSize = fs + "px";
    }
  });
}
if(document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);
addEventListener("load", fitTitles);
addEventListener("resize", ()=>{ clearTimeout(window.__ft); window.__ft = setTimeout(fitTitles, 120); });


document.addEventListener("DOMContentLoaded", function(){

  /* ---- galerie : zoom étiquette + chip + pan ---- */
  const gal = document.getElementById("boutique") || document.querySelector(".gallery");
  let openMRef = null;
  if(gal){
    gal.querySelectorAll(".cell img").forEach(imgFallback);
    gal.querySelectorAll(".cell").forEach((cell,idx)=>{
      const d = DATA[hkey(cell.dataset.handle)];
      cell.style.setProperty("--oy", (d ? d.oy : 54) + "%");
      cell.dataset.pyd = d ? d.pyd : 3;
      const chip = cell.querySelector(".zoomchip");
      if(chip){
        const base = chip.textContent.trim();
        const doAdd = ()=>{ if(cell.dataset.variants && openMRef){ openMRef(idx); return; } addToCart(cell.dataset.vid,1).then(()=>{
          chip.textContent=I18N.added; setTimeout(()=>{chip.textContent=base;},1100); openDrawer();
        }); };
        chip.addEventListener("click", e=>{ e.preventDefault(); e.stopPropagation(); doAdd(); });
        chip.addEventListener("keydown", e=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); e.stopPropagation(); doAdd(); }});
      }
      const ca = cell.querySelector(".cadd2");
      if(ca){
        ca.addEventListener("click", e=>{ e.preventDefault(); e.stopPropagation(); if(cell.dataset.variants && openMRef){ openMRef(idx); return; } addToCart(cell.dataset.vid,1).then(()=>{ const b=ca.textContent; ca.textContent=I18N.added; setTimeout(()=>{ca.textContent=b;},1100); openDrawer(); }); });
      }
    });
  }

  /* ---- page produit : specs + quantité + ajout AJAX ---- */
  const pp = document.querySelector(".pp");
  if(pp){
    const pim = pp.querySelector(".photo img"); if(pim) imgFallback(pim);
    const d = DATA[hkey(pp.dataset.handle)];
    if(d){
      const dot = pp.querySelector("[data-dot]"); if(dot) dot.style.background = d.color;
      const orig = pp.querySelector("[data-orig]");
      if(orig) orig.textContent = pickL(d.origin) + " · SCA " + d.sca;
      const fl = pp.querySelector("[data-flav]"); if(fl) fl.textContent = d.flav;
      const tb = pp.querySelector("[data-specs]");
      if(tb) tb.innerHTML = d.specs.map(s=>"<tr><td>"+s[0]+"</td><td>"+s[1]+"</td></tr>").join("");
      const g = pp.querySelector("[data-g]");
      if(g){
        const gv = v => Math.max(8,(v-1)/2*100).toFixed(0)+"%";
        g.innerHTML = [["Acidité",d.a],["Corps",d.b],["Sucrosité",d.s]]
          .map(x=>'<div><span>'+x[0]+'</span><i data-v="'+gv(x[1])+'" style="--v:0%"></i></div>').join("");
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          g.querySelectorAll("i").forEach(i=>i.style.setProperty("--v", i.dataset.v));
        }));
      }
    }
    let q = 1;
    const qEl = pp.querySelector("[data-q]"), qIn = pp.querySelector("[data-qty]");
    pp.querySelector("[data-minus]").addEventListener("click", ()=>{ q=Math.max(1,q-1); qEl.textContent=q; qIn.value=q; });
    pp.querySelector("[data-plus]").addEventListener("click", ()=>{ q++; qEl.textContent=q; qIn.value=q; });
    const vseg = pp.querySelector(".vopt .vseg");
    if(vseg){
      vseg.addEventListener("click", e=>{
        const b = e.target.closest("button[data-v]"); if(!b || b.disabled) return;
        const vo = vseg.closest(".vopt");
        vo.classList.remove("err");
        document.getElementById("ppForm").querySelector('[name="id"]').value = b.dataset.v;
        vseg.querySelectorAll("button").forEach(x=>{ x.classList.toggle("on", x===b); x.setAttribute("aria-pressed", x===b ? "true" : "false"); });
      });
    }
    const form = document.getElementById("ppForm");
    if(form) form.addEventListener("submit", e=>{
      e.preventDefault();
      const vid = form.querySelector('[name="id"]').value;
      if(!vid){
        const vo = form.querySelector(".vopt");
        if(vo){ vo.classList.add("err"); const s = vo.querySelector("select"); if(s) s.focus(); }
        return;
      }
      addToCart(vid, q).then(openDrawer);
    });
  }


  /* ---- légendes galerie ---- */
  if(gal){
    [].slice.call(gal.querySelectorAll(".cell")).forEach(c=>{
      const d = DATA[c.dataset.handle], n = c.querySelector("[data-note]");
      if(d && n) n.textContent = pickL(d.origin) + " — " + d.flav;
    });
  }

  /* ---- popup produit ---- */
  const modal = $("#modal");
  if(modal && gal){
    const cells = [].slice.call(gal.querySelectorAll(".cell"));
    let mi = 0, mq = 1;
    const gv = v => Math.max(8,(v-1)/2*100).toFixed(0)+"%";
    function fillM(i){
      mi = (i + cells.length) % cells.length; mq = 1; $("#mQty").textContent = 1;
      const c = cells[mi], d = DATA[hkey(c.dataset.handle)] || {};
      const cim = c.querySelector("img"); $("#mImg").src = cim.currentSrc || cim.src; $("#mImg").alt = c.dataset.title || "";
      $("#mDot").style.background = d.color || "#1a1512";
      $("#mName").textContent = c.dataset.title || "";
      $("#mOrig").textContent = pickL(d.origin) ? pickL(d.origin) + " · SCA " + d.sca : "";
      $("#mFlav").textContent = d.flav || "";
      $("#mSpecs").innerHTML = (d.specs || []).map(s=>"<tr><td>"+s[0]+"</td><td>"+s[1]+"</td></tr>").join("");
      const g = $("#mG");
      if(d.a){
        g.innerHTML = [["Acidité",d.a],["Corps",d.b],["Sucrosité",d.s]]
          .map(x=>'<div><span>'+x[0]+'</span><i data-v="'+gv(x[1])+'" style="--v:0%"></i></div>').join("");
        requestAnimationFrame(()=>requestAnimationFrame(()=>{
          g.querySelectorAll("i").forEach(el=>el.style.setProperty("--v", el.dataset.v));
        }));
      } else g.innerHTML = "";
      $("#mPrice").innerHTML = fmtc(+c.dataset.price || 0) + ' <span>/ 200 g</span>';
      const vw = $("#mVopt");
      if(vw){
        if(c.dataset.variants){
          $("#mVlab").textContent = c.dataset.optname || "";
          $("#mVerr").textContent = I18N.grindReq;
          $("#mVseg").innerHTML = JSON.parse(c.dataset.variants).map(v=>'<button type="button" data-v="'+v.id+'" aria-pressed="false">'+v.t+'</button>').join("");
          vw.dataset.sel = "";
          vw.classList.remove("err");
          vw.hidden = false;
        } else vw.hidden = true;
      }
      $("#mLink").href = c.getAttribute("href");
    }
    function openM(i){ fillM(i); modal.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
    openMRef = openM;
    function closeM(){ modal.classList.remove("open"); $("#overlay").classList.remove("open"); if(!$("#drawer").classList.contains("open")) document.body.style.overflow = ""; }
    function navM(dir){
      modal.classList.add("swap");
      setTimeout(()=>{ fillM(mi + dir); modal.classList.remove("swap"); }, 160);
    }
    cells.forEach((c,i)=>c.addEventListener("click", e=>{
      if(e.target.closest(".add2")) return;
      if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault(); openM(i);
    }));
    $("#mClose").addEventListener("click", closeM);
    $("#mPrev").addEventListener("click", ()=>navM(-1));
    $("#mNext").addEventListener("click", ()=>navM(1));
    $("#mMinus").addEventListener("click", ()=>{ mq = Math.max(1, mq-1); $("#mQty").textContent = mq; });
    $("#mPlus").addEventListener("click", ()=>{ mq++; $("#mQty").textContent = mq; });
    $("#mAdd").addEventListener("click", ()=>{
      const vw=$("#mVopt");
      let vid = cells[mi].dataset.vid;
      if(vw && !vw.hidden){
        vid = vw.dataset.sel || "";
        if(!vid){ vw.classList.add("err"); return; }
      }
      addToCart(vid, mq).then(()=>{ closeM(); openDrawer(); });
    });
    $("#mVseg").addEventListener("click", e=>{
      const b = e.target.closest("button[data-v]"); if(!b) return;
      const vw = $("#mVopt");
      vw.dataset.sel = b.dataset.v;
      vw.classList.remove("err");
      $("#mVseg").querySelectorAll("button").forEach(x=>{ x.classList.toggle("on", x===b); x.setAttribute("aria-pressed", x===b ? "true" : "false"); });
    });
    const ov2 = $("#overlay"); if(ov2) ov2.addEventListener("click", closeM);
    document.addEventListener("keydown", e=>{
      if(!modal.classList.contains("open")) return;
      if(e.key === "Escape") closeM();
      if(e.key === "ArrowLeft") navM(-1);
      if(e.key === "ArrowRight") navM(1);
    });
  }

  /* ---- tasses : popup (même fiche modale que les cafés) ---- */
  const cupCards = [].slice.call(document.querySelectorAll(".cup[data-vid]"));
  if(modal && !gal && cupCards.length && !window.__noirCupPopup){
    window.__noirCupPopup = 1;
    let ci = 0, cq = 1;
    const eyeb = modal.querySelector(".eyebrow");
    function fillC(i){
      ci = (i + cupCards.length) % cupCards.length; cq = 1; $("#mQty").textContent = 1;
      const c = cupCards[ci];
      const im = c.querySelector(".cph img");
      $("#mImg").src = im ? im.src : ""; $("#mImg").alt = c.dataset.title;
      $("#mDot").style.display = "none";
      if(eyeb) eyeb.textContent = I18N.cupEyebrow;
      $("#mName").textContent = c.dataset.title;
      $("#mOrig").textContent = c.dataset.dims;
      $("#mFlav").textContent = c.dataset.desc || "";
      $("#mSpecs").innerHTML = JSON.parse(c.dataset.specs).map(s=>"<tr><td>"+s[0]+"</td><td>"+s[1]+"</td></tr>").join("");
      $("#mG").innerHTML = "";
      const vw2=$("#mVopt"); if(vw2) vw2.hidden = true;
      const hasV = !!c.dataset.vid;
      $("#mPrice").innerHTML = c.dataset.pricefmt + ' <span>' + (hasV ? I18N.perPiece : I18N.instore) + '</span>';
      ["#mAdd","#mMinus","#mPlus","#mQty"].forEach(s2=>{ const el=$(s2); if(el) el.style.display = hasV ? "" : "none"; });
      $("#mLink").href = c.dataset.url;
      const nav = cupCards.length > 1 ? "" : "none";
      $("#mPrev").style.display = nav; $("#mNext").style.display = nav;
    }
    function openC(i){ fillC(i); modal.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
    function closeC(){ modal.classList.remove("open"); $("#overlay").classList.remove("open"); if(!$("#drawer").classList.contains("open")) document.body.style.overflow = ""; }
    function navC(dir){ modal.classList.add("swap"); setTimeout(()=>{ fillC(ci + dir); modal.classList.remove("swap"); }, 160); }
    cupCards.forEach((c,i)=>{
      const ph = c.querySelector(".cph a") || c.querySelector(".cph");
      if(ph) ph.addEventListener("click", e=>{
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault(); openC(i);
      });
    });
    $("#mClose").addEventListener("click", closeC);
    $("#mPrev").addEventListener("click", ()=>navC(-1));
    $("#mNext").addEventListener("click", ()=>navC(1));
    $("#mMinus").addEventListener("click", ()=>{ cq = Math.max(1, cq-1); $("#mQty").textContent = cq; });
    $("#mPlus").addEventListener("click", ()=>{ cq++; $("#mQty").textContent = cq; });
    $("#mAdd").addEventListener("click", ()=>{ addToCart(cupCards[ci].dataset.vid, cq).then(()=>{ closeC(); openDrawer(); }); });
    const ov3 = $("#overlay"); if(ov3) ov3.addEventListener("click", closeC);
    document.addEventListener("keydown", e=>{
      if(!modal.classList.contains("open")) return;
      if(e.key === "Escape") closeC();
      if(e.key === "ArrowLeft") navC(-1);
      if(e.key === "ArrowRight") navC(1);
    });
  }

  /* ---- menu mobile ---- */
  const mb = $("#menuBtn"), mm = $("#mmenu");
  if(mb && mm){
    const openMM = ()=>{ mm.classList.add("open"); mb.setAttribute("aria-expanded","true"); document.body.style.overflow="hidden"; };
    const closeMM = ()=>{ mm.classList.remove("open"); mb.setAttribute("aria-expanded","false");
      if(!$("#drawer").classList.contains("open") && !($("#modal")&&$("#modal").classList.contains("open"))) document.body.style.overflow=""; };
    mb.addEventListener("click", ()=>mm.classList.contains("open") ? closeMM() : openMM());
    $("#mmClose").addEventListener("click", closeMM);
    document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeMM(); });
  }

  /* ---- tiroir panier ---- */
  const cb = $("#cartBtn");
  if(cb) cb.addEventListener("click", ()=>{ refreshCart().then(openDrawer); });
  const dc = $("#dClose"); if(dc) dc.addEventListener("click", closeDrawer);
  const ov = $("#overlay"); if(ov) ov.addEventListener("click", closeDrawer);
  const ck = $("#checkout"); if(ck) ck.addEventListener("click", ()=>{ window.location.href="/checkout"; });
  document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeDrawer(); });
  refreshCart();
});
})();


/* ---- tasses : ajout panier ---- */
document.addEventListener("DOMContentLoaded", function(){
  if(window.__noirCupBtns) return; window.__noirCupBtns = 1;
  document.querySelectorAll(".cadd[data-vid]").forEach(function(b){
    b.addEventListener("click", function(){
      window.Noir.add(b.dataset.vid, 1).then(function(){
        var t = b.textContent; b.textContent = I18N.added;
        setTimeout(function(){ b.textContent = t; }, 1100);
        window.Noir.openDrawer();
      });
    });
  });
  /* nav déroulante : repli après clic */
  document.querySelectorAll(".navgrp .sub a").forEach(function(a){
    a.addEventListener("click", function(){
      var g = a.closest(".navgrp"); g.classList.add("snap");
      setTimeout(function(){ g.classList.remove("snap"); }, 400);
    });
  });
});
